import React, { useContext } from "react";
import PropTypes from "prop-types";
import { ThemeContext } from "styled-components";

const Include = ({
  width = "22",
  height = "19",
  strokeWidth = "2",
  strokeColour,
}) => {
  const theme = useContext(ThemeContext);
  const stroke = strokeColour ? strokeColour : theme.COLOURS.PRIMARY.base;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke="none"
        strokeWidth={strokeWidth}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
      >
        <g
          transform="translate(-1565.000000, -161.000000)"
          stroke={stroke}
          strokeWidth={strokeWidth}
        >
          <g transform="translate(1566.000000, 162.000000)">
            <polyline points="0 7.89694155 7.15356534 16 20 0" />
          </g>
        </g>
      </g>
    </svg>
  );
};

Include.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  strokeColour: PropTypes.string,
  strokeWidth: PropTypes.string,
};

export default Include;
